import { useState } from 'react';
import './ToggleButton.css';

const ToggleButton = ({ isActive, onClick }) => {

    return(
        <div className={`toggle-container ${isActive ? 'isActive' : ''}`} id='toggle-container' onClick={()=>{onClick()}}>
            <div className='toggle-button'></div>
        </div>
    )
}

export default ToggleButton;